import React from 'react';

const PlanHighlights = ({dietPlan}) => {
  return(
    <div className='plan-highlights-box mb-4'>
      <h3>Plan Highlights</h3>
      {
        dietPlan.dietPlanType === 'one_month_smart_diet_plan' ?
          <ul className="diet-ul">
            <li>Get an AI generated goal based smart diet plan</li>
            <li>Track calories with 1,00,000+ food data</li>
            <li>Macronutrient tracking</li>
          </ul> :
          <ul className="diet-ul">
            <li>{dietPlan.numberOfDevice} Free smart device worth ₹{dietPlan.deviceWorth}</li>
            <li>Get a goal based diet plan</li>
            <li>Track calories with 1,00,000+ food data</li>
            <li>Macronutrient tracking</li>
            <li>Dedicated health coach</li>
            <li>{dietPlan.personalCalls} personal calls with health coach</li>
            <li>Unlimited chat with health coach</li>
          </ul>
      }
    </div>
  );
};

export default PlanHighlights;